import { render, staticRenderFns } from "./FeedInformation.vue?vue&type=template&id=4feec650"
import script from "./FeedInformation.vue?vue&type=script&lang=js"
export * from "./FeedInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports